const baseUrl =
  "https://api-third-shot-score-684526581556.asia-south1.run.app/";
// const baseUrl = "https://api-pllayer-506323274715.asia-south1.run.app/";

export const getAllSportDetails = async () => {
  const data = await fetch(`${baseUrl}sports`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAmenitiesDetails = async () => {
  const data = await fetch(`${baseUrl}amenities`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getLocationDetails = async () => {
  const data = await fetch(`${baseUrl}locations`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};
export const getAreaDetails = async (formData) => {
  const data = await fetch(
    `${baseUrl}areas?locationId=${formData?.locationId || ""}&locationName=${
      formData.locationName || ""
    }`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const storeVenue = async (formData) => {
  const data = await fetch(`${baseUrl}storevenue`, {
    method: "POST",
    headers: {
      // 'Content-Type': 'multipart/form-data'
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const getAllVenue = async (formData) => {
  if (formData.limit) {
    console.log(formData, "formData");
    let api = formData?.userid
      ? `${baseUrl}venues?userId=${formData?.userid || ""}&location=${
          formData?.location || ""
        }&page=${formData?.offset}&page_size=${formData?.limit}&areaName=${
          formData?.areaName || ""
        }&phoneNumber=${formData?.phoneNumber || ""}&name=${
          formData?.name || ""
        }`
      : `${baseUrl}venues?location=${formData?.location || ""}&page=${
          formData?.offset
        }&page_size=${formData?.limit}&areaName=${
          formData?.areaName || ""
        }&phoneNumber=${formData?.phoneNumber || ""}&name=${
          formData?.name || ""
        }`;

    const data = await fetch(api, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const _data = await data.json();
    return _data;
  } else {
    let api = formData?.userid
      ? `${baseUrl}venues?userId=${formData?.userid || ""}&location=${
          formData?.location || ""
        }&areaName=${formData?.areaName || ""}`
      : `${baseUrl}venues?location=${formData?.location || ""}&areaName=${
          formData?.areaName || ""
        }`;

    const data = await fetch(api, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const _data = await data.json();
    return _data;
  }
};

export const storeSlots = async (formData) => {
  const data = await fetch(`${baseUrl}storeslot`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const updateSlots = async (formData) => {
  const data = await fetch(`${baseUrl}updateslot`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const removeSlots = async (formData) => {
  const data = await fetch(`${baseUrl}removeslot`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getAllBookingSlots = async (formData) => {
  const data = await fetch(
    `${baseUrl}allbookingslot?venue_id=${formData?.venueId}&venue_court_id=${formData?.venueCourtId}&sport_id=${formData?.sportId}&from_date=${formData?.fromDate}&to_date=${formData?.toDate}&admin=true`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const updateSlotDetails = async (formData, id) => {
  const data = await fetch(`${baseUrl}updateslotdetails/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const storeBookingSlots = async (formData) => {
  const data = await fetch(`${baseUrl}bookingslot`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const updatePartialBookingSlots = async (formData) => {
  const data = await fetch(`${baseUrl}updatePartialPayment`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const toggleFastBlock = async (slotId, isBlock) => {
  const data = await fetch(`${baseUrl}togglefastblock`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ slotId, isBlock }),
  });
  const _data = await data.json();
  return _data;
};
export const updateCancelBooking = async (formData) => {
  const data = await fetch(`${baseUrl}cancelBooking`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getAllUserReport = async (formData) => {
  let url = `${baseUrl}manageUser?page=${formData?.offset}&page_size=${
    formData?.limit
  }&name=${formData?.name || ""}&phoneNumber=${
    formData?.phoneNumber || ""
  }&userId=${formData?.userid}&search=${formData?.search || ""}`;
  const data = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAllRevenueAnalysisReport = async (formData) => {
  console.log(formData, "api");
  let api = formData?.userid
    ? `${baseUrl}bookingVenueReport?page=${formData?.offset}&page_size=${
        formData?.limit
      }&from_date=${formData?.fromDate}&to_date=${
        formData?.toDate
      }&venueOwnerId=${formData?.userid || ""}&locationId=${
        formData?.locationId || ""
      }&venueSportId=${formData?.venueSportId || ""}&venueId=${
        formData?.venueId || ""
      }&courtId=${formData?.courtId || ""}&isMembership=${
        formData?.isMembership || ""
      }&search=${formData?.search || ""} `
    : `${baseUrl}bookingVenueReport?page=${formData?.offset}&page_size=${
        formData?.limit
      }&from_date=${formData?.fromDate}&to_date=${
        formData?.toDate
      }&locationId=${formData?.locationId || ""}&venueSportId=${
        formData?.venueSportId || ""
      }&venueId=${formData?.venueId || ""}&courtId=${
        formData?.courtId || ""
      }&isMembership=${formData?.isMembership || ""}&search=${
        formData?.search || ""
      }`;

  const data = await fetch(api, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAllSettlementReport = async (formData) => {
  let api = formData?.userid
    ? `${baseUrl}transactionSettlementList?page=${formData?.offset}&page_size=${
        formData?.limit
      }&from_date=${formData?.fromDate}&to_date=${
        formData?.toDate
      }&venueOwnerId=${formData?.userid || ""} `
    : `${baseUrl}transactionSettlementList?page=${formData?.offset}&page_size=${formData?.limit}&from_date=${formData?.fromDate}&to_date=${formData?.toDate}`;

  const data = await fetch(api, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};
export const getAllRefundsReport = async (formData) => {
  let api = formData?.userid
    ? `${baseUrl}transactionRefundsList?page=${formData?.offset}&page_size=${
        formData?.limit
      }&from_date=${formData?.fromDate}&to_date=${
        formData?.toDate
      }&venueOwnerId=${formData?.userid || ""} `
    : `${baseUrl}transactionRefundsList?page=${formData?.offset}&page_size=${formData?.limit}&from_date=${formData?.fromDate}&to_date=${formData?.toDate}`;

  const data = await fetch(api, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAllCancelBookingReport = async (formData) => {
  console.log("formData: ", formData);
  let api = formData?.userid
    ? `${baseUrl}cancelBookingReport?page=${formData?.offset}&page_size=${
        formData?.limit
      }&from_date=${formData?.fromDate}&to_date=${
        formData?.toDate
      }&venueOwnerId=${formData.userid || ""}&locationId=${
        formData?.locationId || ""
      }&venueSportId=${formData?.venueSportId || ""}&venueId=${
        formData?.venueId || ""
      }&courtId=${formData?.courtId || ""} `
    : `${baseUrl}cancelBookingReport?page=${formData?.offset}&page_size=${
        formData?.limit
      }&from_date=${formData?.fromDate}&to_date=${
        formData?.toDate
      }&locationId=${formData?.locationId || ""}&venueSportId=${
        formData?.venueSportId || ""
      }&venueId=${formData?.venueId || ""}&courtId=${formData?.courtId || ""} `;

  const data = await fetch(api, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAllVenueBookingReport = async (formData) => {
  let api = formData.userid
    ? `${baseUrl}venueBookingReport?page=${formData?.offset}&page_size=${
        formData?.limit
      }&from_date=${formData?.fromDate}&to_date=${
        formData?.toDate
      }&venueOwnerId=${formData?.userid || ""} `
    : `${baseUrl}venueBookingReport?page=${formData?.offset}&page_size=${
        formData?.limit
      }&from_date=${formData?.fromDate}&to_date=${formData?.toDate}&venueId=${
        formData?.venueId || ""
      }&venueCourtId=${formData?.courtId || ""}&sportId=${
        formData?.sportId || ""
      }`;

  const data = await fetch(api, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

// export const loginApi = async (formData) => {
//   const data = await fetch(`${baseUrl}login`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(formData),
//   });
//   const _data = await data.json();
//   return _data;
// };
export const UpdatePaymentStatus = async (formData) => {
  const data = await fetch(`${baseUrl}updateBookingStatus`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const UpdateCancelBookingVenueStatus = async (formData) => {
  const data = await fetch(`${baseUrl}updateCancelBookingStatus`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const venueSlotDetails = async (formData) => {
  const data = await fetch(`${baseUrl}venuesdetailbyvenue/${formData}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};
export const getAllSlotByVenueCourtId = async (formData) => {
  const data = await fetch(
    `${baseUrl}slotByVenueCourtId?venueCourtId=${
      formData?.venueCourtId || ""
    }&days=${formData?.days || ""}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const updateVenueDetails = async (formData, venueId) => {
  const data = await fetch(`${baseUrl}updateVenueDetails/${venueId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const updateVenuePositions = async (positionUpdates) => {
  const data = await fetch(`${baseUrl}updateVenuePositions`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ positionUpdates }),
  });
  const _data = await data.json();
  return _data;
};

export const updateTransactionRefundStatus = async (formData) => {
  const data = await fetch(`${baseUrl}updateTransactionRefundStatus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getAllRating = async (formData) => {
  let url = formData?.userid
    ? `${baseUrl}rating?page=${formData?.offset}&page_size=${
        formData?.limit
      }&venueOwnerId=${formData?.userid}&name=${
        formData?.name || ""
      }&phoneNumber=${formData?.phoneNumber || ""}`
    : `${baseUrl}rating?page=${formData?.offset}&page_size=${
        formData?.limit
      }&name=${formData?.name || ""}&phoneNumber=${
        formData?.phoneNumber || ""
      }`;
  const data = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAppVersion = async () => {
  const data = await fetch(`${baseUrl}app-version`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const storeHostActivity = async (formData) => {
  const data = await fetch(`${baseUrl}friendNPlay/store`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getAllActivity = async (locationId, sportId, date) => {
  const data = await fetch(
    `${baseUrl}friendNPlay?locationId=${locationId}&sportId=${sportId}&date=${date}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const deleteActivity = async (id) => {
  const data = await fetch(`${baseUrl}friendNPlay/delete/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const applyCouponCode = async (formData) => {
  const data = await fetch(`${baseUrl}coupon/checkAvailability`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getLoyalityDetails = async (phoneNumber, venueId) => {
  const data = await fetch(
    `${baseUrl}loyalityDetailsByVenueId?phoneNumber=${phoneNumber}&venueId=${venueId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};
export const getMembershipDetails = async (phoneNumber, venueId) => {
  const data = await fetch(
    `${baseUrl}membershipDetailsByVenueId?phoneNumber=${phoneNumber}&venueId=${venueId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const getUserBookingDetails = async (userId, venueId) => {
  const data = await fetch(
    `${baseUrl}userBookingReport?userId=${userId}&venueId=${venueId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const getActiveMembershipActiveByVenueId = async (venueId) => {
  const data = await fetch(
    `${baseUrl}getAllActiveMembershipUsers?venueId=${venueId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const addMembershipPointsByVenueId = async (formData) => {
  const data = await fetch(`${baseUrl}addMembershipPoints`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

// PlayPoints API functions
export const getActivePlayPointsByVenueId = async (venueId) => {
  const data = await fetch(
    `${baseUrl}getAllActiveLoyaltyUsers?venueId=${venueId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const _data = await data.json();
  return _data;
};

export const addPlayPointsByVenueId = async (formData) => {
  const data = await fetch(`${baseUrl}addLoyaltyPoints`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const getReviewByVenue = async (id) => {
  const data = await fetch(`${baseUrl}rating/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

// export const changePasswordAPI = async (formData) => {
//   const token = localStorage.getItem("token");
//   const data = await fetch(`${baseUrl}updatePassword`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//     body: JSON.stringify(formData),
//   });
//   const _data = await data.json();
//   return _data;
// };

// User Management API functions
export const getUsersByVenueId = async (venueId) => {
  const data = await fetch(`${baseUrl}usersByVenueId?venueId=${venueId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const createUserRole = async (formData) => {
  const data = await fetch(`${baseUrl}createUserRole`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const deleteUserRole = async (id) => {
  const data = await fetch(`${baseUrl}deleteUserRole/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getAllVenueUserDetails = async (id) => {
  const data = await fetch(`${baseUrl}userByVenue?venueId=${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

// Court Management API functions
export const getVenueCourts = async (venueId) => {
  const data = await fetch(`${baseUrl}venueCourts?venueId=${venueId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const createVenueCourt = async (formData) => {
  const data = await fetch(`${baseUrl}venueCourts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const updateVenueCourt = async (courtId, formData) => {
  const data = await fetch(`${baseUrl}venueCourts/${courtId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const deleteVenueCourt = async (courtId) => {
  const data = await fetch(`${baseUrl}venueCourts/${courtId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const getVenueSports = async (venueId) => {
  const data = await fetch(`${baseUrl}venueSports?venueId=${venueId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const createVenueSport = async (formData) => {
  const data = await fetch(`${baseUrl}venueSports`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const updateVenueSport = async (venueSportId, formData) => {
  const data = await fetch(`${baseUrl}venueSports/${venueSportId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const deleteVenueSport = async (venueSportId) => {
  const data = await fetch(`${baseUrl}venueSports/${venueSportId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

// Coupon Management API functions
export const getAllCoupons = async (venueId) => {
  const data = await fetch(`${baseUrl}coupon/venue/${venueId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const createCoupon = async (formData) => {
  const data = await fetch(`${baseUrl}coupon/store`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const updateCoupon = async (couponId, formData) => {
  const data = await fetch(`${baseUrl}coupon/update/${couponId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const deleteCoupon = async (couponId) => {
  const data = await fetch(`${baseUrl}coupon/delete/${couponId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

// Team Management API functions
export const getAllTeams = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}teams`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const getTeamById = async (teamId) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}teams/${teamId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const createTeam = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}teams`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const updateTeam = async (teamId, formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}teams/${teamId}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const deleteTeam = async (teamId) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}teams/${teamId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const getTeamsWithPlayerCount = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}teams/with-count`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const getTeamsWithPlayersSortedByScore = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}teams/with-players-sorted`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

// Player Management API functions
export const getAllPlayers = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}players`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const getPlayerById = async (playerId) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}players/${playerId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const getPlayersByTeamId = async (teamId) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}players/team/${teamId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const getPlayersWithoutTeam = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}players/without-team`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const createPlayer = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}players`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const updatePlayer = async (playerId, formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}players/${playerId}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const deletePlayer = async (playerId) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}players/${playerId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const transferPlayer = async (playerId, newTeamId) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}players/${playerId}/transfer`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ newTeamId }),
  });
  const _data = await data.json();
  return _data;
};

export const getAllPlayersSortedByScore = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}players/sorted-by-score`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

// Get all matches for CSV export
export const getMatchesForExport = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}pickleball/matches/export`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

// Authentication API functions
export const loginApi = async (formData) => {
  const data = await fetch(`${baseUrl}auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getProfile = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}auth/profile`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const changePasswordAPI = async (formData) => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}auth/change-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const logoutAPI = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}auth/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const verifyTokenAPI = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}auth/verify-token`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const createDefaultAdminAPI = async () => {
  const data = await fetch(`${baseUrl}auth/create-default-admin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

// Display Settings API functions (slot 1 = Display 1, slot 2 = Display 2)
export const getDisplaySettings = async (slot = 1) => {
  const token = localStorage.getItem("token");
  const s = Number(slot) === 2 ? 2 : 1;
  const data = await fetch(`${baseUrl}display-settings?slot=${s}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};

export const updateDisplaySettings = async (formData, slot = 1) => {
  const token = localStorage.getItem("token");
  const s = Number(slot) === 2 ? 2 : 1;
  const data = await fetch(`${baseUrl}display-settings?slot=${s}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const getDisplaySettingsTeams = async () => {
  const token = localStorage.getItem("token");
  const data = await fetch(`${baseUrl}display-settings/teams`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const _data = await data.json();
  return _data;
};
